import {
  Button,
  PhoneMockup,
  PhoneMockupBodyLayout,
  PhoneMockupLayout,
  Text,
  TextLink,
  WidgetHeader,
  WidgetHeaderContent,
  WidgetStatus,
} from '@frontend/ui-library';
import { getIdFromUrl } from '@frontend/utils';
import { useEffect } from 'react';

import { SatisfactionRating } from '../../components';
import links from '../../constants/links';
import { useWidgetContext } from '../../context/WidgetContext';

import { PageFields_CancelledPage_Fragment as PaymentCanceledPageFields } from '../../graphql/generated';
import { useRegisterHotjarPage } from '../../hooks';

interface RefundInitiatedProps {
  data: PaymentCanceledPageFields['cancelledPageData'];
}

const RefundInitiated = (props: RefundInitiatedProps) => {
  const { configureHeader } = useWidgetContext();
  useRegisterHotjarPage('refund-initiated');

  useEffect(() => {
    configureHeader({
      id: getIdFromUrl(),
      merchantName: props.data?.merchantName || '',
    });
  }, []);

  return (
    <PhoneMockupLayout>
      <PhoneMockup
        header={
          <WidgetHeader color="success">
            <WidgetHeaderContent title="Success" />
          </WidgetHeader>
        }
      >
        <PhoneMockupBodyLayout
          bodyCentered
          body={
            <>
              <WidgetStatus
                emoji="💸"
                title="Refund initiated"
                description="We’ve sent you an email with refund instructions."
              />
              <SatisfactionRating
                mt="32"
                rating={props.data?.rating || undefined}
              />
            </>
          }
          footer={
            <>
              <Text size="tiny" color="neutral-500" align="center">
                Didn’t get the email? Please check your spam folder. If you
                still don’t see it, please reach out to{' '}
                <TextLink
                  size="tiny"
                  href={links.support.HOME}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  our support.
                </TextLink>
              </Text>
              {props.data?.cancelUrl && (
                <Button
                  as="a"
                  href={props.data.cancelUrl}
                  mt="16"
                  size="large"
                  variant="secondary"
                >
                  Go back to store
                </Button>
              )}
            </>
          }
        />
      </PhoneMockup>
    </PhoneMockupLayout>
  );
};

export default RefundInitiated;
